import type { REDIRECT_TO_VOLTACALL_BTN_FRENCH_LOCALE } from "~ui/@application/locales/modules/components/redirect-to-voltacall-btn/redirect-to-voltacall-btn.fr.ts";

export const REDIRECT_TO_VOLTACALL_BTN_ENGLISH_LOCALE = {
  openInVoltacall: "Ouvrir dans VoltaCall",
} satisfies typeof REDIRECT_TO_VOLTACALL_BTN_FRENCH_LOCALE;
